<template>
  <!-- The message a reply quotes, WhatsApp-style: a bar in the author's
       accent, who wrote it, what it said (or sent), and its picture when it
       had one. In a reply it is a button that jumps to the original; above
       the composer it only shows what is being replied to. -->
  <component
    :is="clickable ? 'button' : 'div'"
    :type="clickable ? 'button' : null"
    class="sc-quote"
    :class="{ 'sc-quote--mine': mine, 'is-deleted': quote.isDeleted, 'is-clickable': clickable }"
    :title="clickable ? 'Go to the original message' : null"
    :aria-label="clickable ? `Replying to ${authorLabel}: ${text}. Go to the original message.` : null"
    @click="onClick"
  >
    <span class="sc-quote__main">
      <span class="sc-quote__author">{{ authorLabel }}</span>
      <span class="sc-quote__text">
        <i v-if="icon" class="pi" :class="icon" aria-hidden="true"></i>
        {{ text }}
      </span>
    </span>
    <img v-if="quote.thumbnail && !quote.isDeleted" class="sc-quote__thumb" :src="quote.thumbnail" alt="" loading="lazy" />
  </component>
</template>
<script>
const KIND_ICONS = { voice: 'pi-microphone', image: 'pi-image', file: 'pi-paperclip', deleted: 'pi-ban' };

export default {
  name: 'ChatQuote',
  props: {
    // { id, authorSide, authorId, author, preview, kind, isDeleted, thumbnail } (utils/chat chatQuoteOf).
    quote: {
      type: Object,
      required: true,
    },
    // Who wrote it, as the viewer knows them: "You", "Abel", "Moshe Levi".
    authorLabel: {
      type: String,
      default: '',
    },
    // Inside one of this side's (coloured) bubbles.
    mine: {
      type: Boolean,
      default: false,
    },
    // A reply's quote jumps to the original; the composer's does not.
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['jump'],
  computed: {
    icon() {
      return this.quote.isDeleted ? KIND_ICONS.deleted : KIND_ICONS[this.quote.kind] || '';
    },
    text() {
      return this.quote.isDeleted ? 'This message was deleted' : this.quote.preview || 'Message';
    },
  },
  methods: {
    onClick(event) {
      if (!this.clickable) return;
      event.stopPropagation();
      this.$emit('jump');
    },
  },
};
</script>
